import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import OptionGroupsTable from '../../components/optionGroups/OptionGroupsTable';

const OptionGroups = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <OptionGroupsTable />
        </WrapperSection>
    );
};

export default OptionGroups;
